import React from 'react';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import SmallExclamationCircle from 'components/common/icons/redesign/SmallExclamationCircle';
import SmallPlusIcon from 'components/common/icons/redesign/SmallPlusIcon';

import { makeURL } from 'components/common/apiPrefix';
import { formatNotificationsDate, NOTIFICATIONS_FORMATTER } from 'helpers/notificationsHelpers';
import { NOTIFICATIONS_TYPES } from 'constants/NotificationsConstants';

import style from './NotificationItem.module.scss';

const NotificationItem = ({ notification, history, withReadStatus }) => {
    const { t } = useTranslation();
    const avatarURL = getAvatar(notification);

    const currentTime = dayjs.utc();
    const date = dayjs.utc(notification.created);
    const differenceInMinutes = currentTime.diff(date, 'minute', 'true');
    const notificationContent = NOTIFICATIONS_FORMATTER[notification.type](
        notification.type,
        notification.data,
        history,
        t,
    );
    const displayUnreadStatus = withReadStatus && !notification.read;
    const avatarClassName = cn(style.avatar, {
        [style.withReadStatus]: displayUnreadStatus,
        [style.adminAvatar]: notification.isAdminSource,
    });

    return (
        <div className={style.notification}>
            <div className={style.withBorder}>
                <div className={avatarClassName} style={{ backgroundImage: `url(${avatarURL})` }}>
                    {getNotificationIcon(notification.type)}
                </div>
                <div className={style.itemContent}>
                    <div className={style.text}>{notificationContent}</div>
                    <div className={style.date}>{formatNotificationsDate(differenceInMinutes, t)}</div>
                </div>
            </div>
        </div>
    );
};

const EXCLAMATION_TYPES = [
    NOTIFICATIONS_TYPES.clientInvitationDecline,
    NOTIFICATIONS_TYPES.clientDisputeResponse,
    NOTIFICATIONS_TYPES.resourceOpenedDispute,
    NOTIFICATIONS_TYPES.resourceDisputeResponse,
    NOTIFICATIONS_TYPES.resourceInterviewRescheduled,
    NOTIFICATIONS_TYPES.resourceInterviewInOneDay,
    NOTIFICATIONS_TYPES.resourceInterviewInThreeDays,
    NOTIFICATIONS_TYPES.resourceInterviewCancellation,
    NOTIFICATIONS_TYPES.resourceInterviewFire,
    NOTIFICATIONS_TYPES.outdatedKycStatus,
];

const getNotificationIcon = (type) => {
    if (EXCLAMATION_TYPES.includes(type)) return <SmallExclamationCircle className={style.exclamationIcon} />;
    return <SmallPlusIcon className={style.plusIcon} />;
};

export const getAvatar = (notification) => {
    if (notification.isAdminSource) return '/favicon.ico';
    return notification.source && notification.source.avatar
        ? makeURL(notification.source.avatar)
        : '/defaultAvatar.svg';
};

export default withRouter(NotificationItem);
